<div class="printable">
  <authority-labs-base-certificate-details
    [order]="order"
    [project]="project"
    [subProject]="subProject"
    [company]="company"
    [contact]="contact"
    [assignee]="assignee"
    [approval]="approval"
    [inspection]="inspection"
    [systemDescription]="systemDescription"
  ></authority-labs-base-certificate-details>

  <div class="page-break"></div>

  <authority-labs-failed-inspection-notes
    [inspectionCases]="
      getInspectionCases(
        inspection.inspectionPressureSystemInStairwellsCompatibilityCheck?.cases
      )
    "
  ></authority-labs-failed-inspection-notes>

  <authority-labs-pressure-system-in-stairwells-compatibility-check-test-results
    [inspection]="
      inspection.inspectionPressureSystemInStairwellsCompatibilityCheck
    "
  >
  </authority-labs-pressure-system-in-stairwells-compatibility-check-test-results>

  <p style="text-align: center">
    <strong style="font-size: 5pt; position: relative; top: -5px"
      >&#10033;</strong
    >
    <strong style="font-size: 14pt">סוף תעודת בדיקה</strong>
    <strong style="font-size: 5pt; position: relative; top: -5px"
      >&#10033;</strong
    >
  </p>
</div>
